export enum IComparisonTableScrollDirection {
    LEFT,
    RIGHT
}
export enum IComparisonTableScrollDirection {
    LEFT,
    RIGHT
}
